<template>
    <div class="HeadPageImage" :class="class_root">
        <Responsive :breakPoint="state.props.Responsive['0'].breakPoint"
                :verticalBreakPoint="state.props.Responsive['0'].verticalBreakPoint"
                :breakPoints="state.props.Responsive['0'].breakPoints"
                :verticalBreakPoints="state.props.Responsive['0'].verticalBreakPoints"
                :onBreakPointChange="state.props.Responsive['0'].onBreakPointChange"
                :onVerticalBreakPointChange="state.props.Responsive['0'].onVerticalBreakPointChange">
          <div class="HeadPageImage--forms">
            <div class="HeadPageImage--Title">
              <Title :uppercase="false">{{ this.title }}</Title>
              <Title :uppercase="false" type="small">{{ this.subTitle }}</Title>
              <Title>
                <img src="/img/global/doubleArrow.svg" alt="Double Arrow"/>
              </Title>
            </div>  
            <div class="HeadPageImage--forms-circles">
              <div class="HeadPageImage--forms-circles-image HeadPageImage--forms-circles-icon-1">
                <img :src="`/img/${this.icon1}`" :alt="this.altIcon1" />
              </div>
              <div class="HeadPageImage--forms-circles-image HeadPageImage--forms-circles-icon-2">
                <img :src="`/img/${this.icon2}`" :alt="this.altIcon2" />
              </div>
              <div class="HeadPageImage--forms-circles-image HeadPageImage--forms-circles-image-1">
                <img :src="`/img/${this.img1}`" :alt="this.altImg1" />
              </div>
              <div class="HeadPageImage--forms-circles-image HeadPageImage--forms-circles-image-2">
                <img :src="`/img/${this.img2}`" :alt="this.altImg2" />
              </div>
              <div class="HeadPageImage--forms-circles-image HeadPageImage--forms-circles-image-3">
                <img :src="`/img/${this.img3}`" :alt="this.altImg3" />
              </div>
              <div class="HeadPageImage--forms-circles-image HeadPageImage--forms-circles-image-4">
                <img :src="`/img/${this.img4}`" :alt="this.altImg4" />
              </div>
            </div>
            <div class="HeadPageImage--form-curved">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#FFF" fill-opacity="1" d="M0,224L40,240C80,256,160,288,240,266.7C320,245,400,171,480,128C560,85,640,75,720,80C800,85,880,107,960,133.3C1040,160,1120,192,1200,186.7C1280,181,1360,139,1400,117.3L1440,96L1440,320L1400,320C1360,320,1280,320,1200,320C1120,320,1040,320,960,320C880,320,800,320,720,320C640,320,560,320,480,320C400,320,320,320,240,320C160,320,80,320,40,320L0,320Z"></path></svg>
            </div>
            <div class="HeadPageImage--form-1">
              <GridH></GridH>
            </div>
            <div class="HeadPageImage--form-2">
              <GridH></GridH>
            </div>
            <div class="HeadPageImage--form HeadPageImage--form-3"></div>
            <div class="HeadPageImage--form HeadPageImage--form-4"></div>
          </div>
          
        </Responsive>
    </div>
</template>

<script>
// -----

import BreakPoint from '@bbx/responsive~master/core/delta/BreakPoint';
import SCREEN from '@bbx/responsive~master/core/constant/SCREEN';
import {ListenerRegister} from "@bbx/listener~master/core/delta/ListenerRegister";
import {ListenerTrigger} from "@bbx/listener~master/core/delta/ListenerTrigger";
import {eventService} from "../../service/eventService";
import {EVENT} from "../../constant/EVENT";

// -----

export default {
    name: 'HeadPageImage',
    props: ['title','subTitle','icon1','icon2', 'img1', 'img2', 'img3', 'img4','altIcon1','altIcon2', 'altImg1', 'altImg2', 'altImg3', 'altImg4'],
    data() {
    return {
      state: {
        props: {
          Responsive: {
            "0": {
              breakPoint: new BreakPoint({
                name: SCREEN.DESKTOP
              }),
              verticalBreakPoint: new BreakPoint(),
              breakPoints: [
                new BreakPoint({
                  name: SCREEN.MOBILE,
                  width: 0
                }),
                new BreakPoint({
                  name: SCREEN.TABLET,
                  width: 900
                }),
                new BreakPoint({
                  name: SCREEN.DESKTOP,
                  width: 1440
                }),
              ],
              verticalBreakPoints: [
                new BreakPoint({
                  name: SCREEN.MOBILE,
                  height: 0
                }),
                new BreakPoint({
                  name: SCREEN.DESKTOP,
                  height: 600
                }),
              ],
              onBreakPointChange: (v) => this.state.props.Responsive['0'].breakPoint = v,
              onVerticalBreakPointChange: (v) => this.state.props.Responsive['0'].verticalBreakPoint = v,
            },
          },
        },
        animated: false,
        loaded: false,
      },
      events: []
    }
  },
  watch: {},
  computed: {
    class_root() {
      const classes = []
      if (this.state.props.Responsive['0'].breakPoint.name === SCREEN.MOBILE) classes.push(`HeadPageImage-mobile`)
      if (this.state.props.Responsive['0'].breakPoint.name === SCREEN.TABLET) classes.push(`HeadPageImage-tablet`)
      if (this.state.props.Responsive['0'].breakPoint.name === SCREEN.DESKTOP) classes.push(`HeadPageImage-desktop`)
      if (this.state.props.Responsive['0'].verticalBreakPoint.name === SCREEN.MOBILE) classes.push(`HeadPageImage-mobileY`)
      if (this.state.props.Responsive['0'].verticalBreakPoint.name === SCREEN.DESKTOP) classes.push(`HeadPageImage-desktopY`)
      if (this.state.animated) classes.push(`HeadPageImage-animated`)
      return classes
    }
  },
  beforeMount() {
    this.events.push(new ListenerRegister({
      name: EVENT.START_ANIMATION,
      callback: () => {
        setTimeout(() => this.start(), 3000)
      }
    }))

    // -----

    for (const event of this.events) {
      eventService.register(event)
    }
  },
  mounted() {
  },
  beforeDestroy() {
    for (const event of this.events) {
      eventService.unregister(event)
    }
  },
  methods: {
    start() {
      this.state.animated = true
    },
    onLoaded() {
      this.state.loaded = true
      this.start()
    }
  }
}
</script>

<style scoped>
.HeadPageImage {
  --height-screen: 100vh;
  height: var(--height-screen);
  overflow: hidden;
}

.HeadPageImage--forms {
  width: 100%;
  height: calc(var(--height-screen) + -1px);
  background: linear-gradient(90deg,var(--colorLigher) 15%,var(--colorDarker) 60%);
  position: relative;
  color: #FFF;
  text-align: center;
}

.HeadPageImage--form-curved svg {
  transform: scaleX(-1);
  display: block;
  position: absolute;
  bottom: -1px;
}

.HeadPageImage--form {
  position: absolute;
  border-radius: 10000px;
  background: rgba(255, 255, 255, 0.1);
}

[class^="HeadPageImage--form-"]:not(.HeadPageImage--form-curved) {
  position: absolute;
}

.HeadPageImage-desktop .HeadPageImage--form-1 {
  left: 200px;
  top: 100px;
}

.HeadPageImage-mobile .HeadPageImage--form-1 {
  right: -90px;
  top: 30px;
}

.HeadPageImage-tablet .HeadPageImage--form-1 {
  right: -90px;
  top: 30px;
}

.HeadPageImage-desktop .HeadPageImage--form-2 {
  right: -50px;
  top: 50px;
}

.HeadPageImage-mobile .HeadPageImage--form-2 {
  display: none;
}

.HeadPageImage-tablet .HeadPageImage--form-2 {
  left: 70px;
  top: 80px;
}

.HeadPageImage--form-3 {
  width: 400px;
  height: 400px;
}

.HeadPageImage-desktop .HeadPageImage--form-3 {
  left: -85px;
  bottom: -50px;
}

.HeadPageImage-mobile .HeadPageImage--form-3 {
  left: -215px;
  bottom: -135px;
}

.HeadPageImage-tablet .HeadPageImage--form-3 {
  left: -50px;
  bottom: -150px;
}

.HeadPageImage--form-4 {
  width: 200px;
  height: 200px;
}

.HeadPageImage-desktop .HeadPageImage--form-4 {
  right: 20px;
  bottom: 2%;
}

.HeadPageImage-tablet .HeadPageImage--form-4 {
  right: -50px;
  bottom: -0px;
}

.HeadPageImage-mobile .HeadPageImage--form-4 {
  display: none;
}

.HeadPageImage >>> .Title span {
  color: #FFF;
}

.HeadPageImage >>> .Title-small {
  margin: 30px 0;
}

.HeadPageImage--Title {
  margin: 0;
  position: absolute;
  top: 35%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.HeadPageImage--forms-circles-image {
  position: absolute;
  background-color: #FFFFFF;
  border-radius: 100%;
  box-shadow: 0px 10px 30px 5px rgba(119, 119, 119, 0.1);
}

.HeadPageImage-mobile .HeadPageImage--forms-circles-image {
  display: none;
}

.HeadPageImage--forms-circles-image img {
  position: relative;
}

.HeadPageImage--forms-circles-icon-1 {
  width: 50px;
  height: 50px;
  top: 255px;
  left: 380px;
}

.HeadPageImage-tablet .HeadPageImage--forms-circles-icon-1 {
  top: 200px;
  left: 295px;
}

.HeadPageImage--forms-circles-icon-1 img {
  width: 30px;
  border-radius: 0%;
  left: 20px;
  top: 5px;
  transform: translateX(-50%);
}

.HeadPageImage--forms-circles-icon-2 {
  width: 100px;
  height: 100px;
  top: 250px;
  right: 370px;
}

.HeadPageImage-tablet .HeadPageImage--forms-circles-icon-2 {
  top: 165px;
  right: 125px;
}

.HeadPageImage--forms-circles-icon-2 img {
  width: 80px;
  height: 80px;
  border-radius: 0%;
  left: 40px;
  top: 10px;
  transform: translateX(-50%);
}

.updateIconMentionsLegales .HeadPageImage--forms-circles-icon-1 img {
  width: 35px;
  height: 35px;
  border-radius: 0%;
  left: 19px;
  top: 7px;
  transform: translateX(-50%);
}

.updateIconMentionsLegales .HeadPageImage--forms-circles-icon-2 img {
  width: 70px;
  height: 70px;
  border-radius: 0%;
  left: 40px;
  top: 15px;
  transform: translateX(-50%);
}

.updateIconCGV .HeadPageImage--forms-circles-icon-1 img {
  width: 35px;
  height: 35px;
  border-radius: 0%;
  left: 18px;
  top: 6px;
  transform: translateX(-50%);
}

.updateIconCGV .HeadPageImage--forms-circles-icon-2 img {
  width: 70px;
  height: 70px;
  border-radius: 0%;
  left: 40px;
  top: 15px;
  transform: translateX(-50%);
}

.updateIconPolitique  .HeadPageImage--forms-circles-icon-1 {
  width: 50px;
  height: 50px;
  top: 255px;
  left: 380px;
}

.updateIconPolitique .HeadPageImage--forms-circles-icon-1 img {
  width: 35px;
  height: 35px;
  border-radius: 0%;
  left: 18px;
  top: 8px;
  transform: translateX(-50%);
}

.HeadPageImage--forms-circles-image-1 {
  width: 110px;
  height: 110px;
  height: 110px;
  top: 575px;
  right: 330px;
  z-index: 1;
}

.HeadPageImage--forms-circles-image-1 img {
  width: 100px;
  height: 100px;
  border-radius: 100%;
  left: 50px;
  top: 5px;
  transform: translateX(-50%);
}

.HeadPageImage--forms-circles-image-2 {
  width: 110px;
  height: 110px;
  top: 535px;
  left: 375px;
  z-index: 1;
}

.HeadPageImage--forms-circles-image-2 img {
  width: 100px;
  height: 100px;
  border-radius: 100%;
  left: 50px;
  top: 5px;
  transform: translateX(-50%);
}

.HeadPageImage--forms-circles-image-3 {
  width: 90px;
  height: 90px;
  top: 400px;
  left: 140px;
}

.HeadPageImage-tablet .HeadPageImage--forms-circles-image-1,
.HeadPageImage-tablet .HeadPageImage--forms-circles-image-2 {
  display: none;
}

.HeadPageImage--forms-circles-image-3 img {
  width: 80px;
  height: 80px;
  border-radius: 100%;
  left: 40px;
  top: 5px;
  transform: translateX(-50%);
}

.HeadPageImage--forms-circles-image-4 {
  width: 130px;
  height: 130px;
  top: 400px;
  right: 180px;
  z-index: 1;
}

.HeadPageImage-tablet .HeadPageImage--forms-circles-image-4 {
  top: 380px;
  right: 200px;
}

.HeadPageImage--forms-circles-image-4 img {
  width: 120px;
  height: 120px;
  border-radius: 100%;
  left: 60px;
  top: 5px;
  transform: translateX(-50%);
}

</style>